<template>
  <v-app id="apply">
    <v-navigation-drawer v-model="toggle" app right>
      <v-list nav dense>
        <v-subheader></v-subheader>
        <v-list-item-group v-model="selectedItem" color="primary">
          <v-list-item v-for="(item, i) in items" :key="i">
            <v-list-item-icon>
              <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <router-link :to="{ name: item.to }" class="ml-2">
                <v-list-item-title v-text="item.text"></v-list-item-title>
              </router-link>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <v-container fluid class="grey lighten-5 pa-0">
      <v-app-bar app>
        <v-img
          lazy-src="@/assets/logo.png"
          max-height="30"
          max-width="30"
          src="@/assets/logo.png"
        />
        <v-toolbar-title class="ml-1" @click="goToHome"
          >토마토세븐</v-toolbar-title
        >
        <v-spacer />
        {{ userName }}
        <v-app-bar-nav-icon @click="toggle = !toggle" />
      </v-app-bar>
      <!-- Sizes your content based upon application components -->
      <v-main>
        <!-- If using vue-router -->
        <router-view />
      </v-main>

      <v-footer app>
        <!-- -->
      </v-footer>
    </v-container>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from "vuex"; // mapGetters를 추가한다
const register = "register";

export default {
  name: "Zaka",
  data() {
    return {
      toggle: false,

      selectedItem: 1,
      items: [
        { text: "HOME", icon: "mdi-home", to: "applyHome" },
        { text: "BoardAA", icon: "mdi-account", to: "applyBoardAA" },
        { text: "Conversions", icon: "mdi-flag", to: "applyHome" },
      ],
    };
  },
  computed: {
    filter() {
      return this.caseSensitive
        ? (item, search, textKey) => item[textKey].indexOf(search) > -1
        : undefined;
    },
    // 1) 이름 지정해서 가져오기
    ...mapGetters(register, {
      storeUserName: "getUid",
      storeUserStatus: "getIsAuth",
      menu01: "GE_MENU01",
    }),
  },
  watch: {
    // getters에 watch를 걸 수 있습니다.
    storeUserName(val) {
      this.userName = val;
    },
    storeUserStatus(val) {
      this.userStatus = val;
    },
  },
  created() {
    this.userName = this.storeUserName;
    this.userStatus = this.storeUserStatus;
  },
  methods: {
    ...mapGetters(register, ["getUid"]),
    ...mapActions(register, ["LogOut"]),
    goToHome() {
      this.$router.push({
        name: "applyHome",
      });
    },
  },
};
</script>
<style scoped>
.v-overlay {
  z-index: 6 !important;
}
a {
  text-decoration: none;
}
</style>
